import api from "./api";

export const upload = async (data,id) => {
  return await api.put(`/card/update/${id}`,data);
};


export const cardUpload = async (data)=>{
  return await api.post(`/card/upload`,data);
}